"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNumber = void 0;
/**
 * @summary Determines if a string contains a float number.
 *
 * Checks if a string contains a number. Float values are accepted. Whitespace at the beginning and end
 * are ignored. Both `,` and `.` are accepted as decimal separators.
 *
 * @param {string | undefined} text
 * @returns {boolean}
 *
 * @example
 * if (isNumber('33.5')) {
 *   // ...
 * }
 */
function isNumber(text) {
    const t = text?.replace(/,/g, '.');
    return !!t?.trim() && !isNaN(+t) && isFinite(+t);
}
exports.isNumber = isNumber;
